import React, { useEffect, useRef, useState } from 'react';

const LazyImage = ({ src, alt = '', className, rootMargin = '100px' }) => {
  const ref = useRef(null);
  const observerRef = useRef(null);

  const [visible, setVisible] = useState(false);

  // Reset visibility when image source changes
  useEffect(() => {
    setVisible(false);
  }, [src]);

  // Create observer ONCE
  useEffect(() => {
    if (!ref.current) return;

    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);

          if (observerRef.current) {
            observerRef.current.disconnect();
          }
        }
      },
      { rootMargin }
    );

    const el = ref.current;
    observerRef.current.observe(el);

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, []);

  return (
    <div ref={ref} style={{ display: 'block' }}>
      {visible ? (
        <img
          src={src}
          alt={alt}
          className={className}
          loading="lazy"
          decoding="async"
        />
      ) : (
        <div
          className={className}
          style={{
            background: '#eee'
          }}
        />
      )}
    </div>
  );
};

export default LazyImage;
